<template>
	<section class="LoginPage">
		<form v-if="showOtpLogin === false" :class="{'LoginForm':true, 'hide':hidden}"
          @submit.prevent="submitForm">
			<a class="LoginForm-logo" href="https://thermo.solutions/">
				<img src="/map/dist/skin/logo.svg" alt="Logo" />
			</a>
			<div class="LoginForm-row">
				<label>Gebruikersnaam</label>
				<input class="TextField" type="text" name="username" v-model="username" />
			</div>
			<div class="LoginForm-row">
				<label>Wachtwoord</label>
				<input class="TextField" type="password" name="password" v-model="password" />
			</div>
			<div class="LoginForm-row">
				<Button type="submit" :primary="true" @click="submitForm" :disabled="isLoading">Inloggen</Button>
			</div>
			<p v-if="invalidCredentials">Inloggegevens zijn niet correct</p>
			<LoadingIndicator v-if="isLoading" />
		</form>
    <form v-else :class="{'LoginForm':true, 'hide':hidden}" @submit.prevent="verifyTotpForm">
      <a class="LoginForm-logo" href="https://thermo.solutions/">
        <img src="/map/dist/skin/logo.svg" alt="Logo" />
      </a>
      <div class="LoginForm-row">
        <label>Twee staps verificatie code</label>
        <input class="TextField" type="text" name="code" v-model="code" />
      </div>
	    <div class="LoginForm-row checkbox-container">
		    <input class="checkbox" type="checkbox" id="trusted_device" name="trusted_device"
		           v-model="trusted_device"><label
		    for="trusted_device">Vertrouwd apparaat</label>
      </div>
      <div class="LoginForm-row">
        <Button type="submit" :primary="true" :disabled="isLoading">Inloggen</Button>
      </div>
      <p v-if="invalidCode">Twee staps verificatie code is niet correct</p>
      <LoadingIndicator v-if="isLoading" />
    </form>
	</section>
</template>

<script>
	import { mapState, mapActions } from 'vuex';
	import Button from '@/components/Button';
	import LoadingIndicator from '@/components/LoadingIndicator';

	export default {
		components: {
			Button,
			LoadingIndicator,
		},

		data() {
			return {
				username: '',
				password: '',
				invalidCredentials: false,
				hidden: false,
        showOtpLogin: false,
        invalidCode: false,
        code: '',
		trusted_device: false,
        returnUrl: this.$router.currentRoute.query.returnUrl,
			};
		},

		computed: {
			...mapState({
				isLoading: 'loading',
			}),
		},

		methods: {
			...mapActions({
				loginUser: 'auth/loginUser',
        verifyTotp: 'auth/verifyTotp',
			}),

			submitForm() {
				this.hidden = false;
				this.invalidCredentials = false;

				this.loginUser({
					username: this.username,
					password: this.password,
				}).then((viewer) => {
          if(viewer === 'otp_required') {
            this.showOtpLogin = true;
            return;
          }
					this.hidden = true;
					this.invalidCredentials = false;

					this.$notify({
						group: 'app',
						title: 'Inloggen',
						type: 'success',
						text: `Welkom ${viewer.display_name != null ? viewer.display_name : viewer.username}`
					});

					setTimeout(() => {
            if(this.returnUrl != null) {
              this.$router.push({path: this.returnUrl}).catch((error) => { if (error) console.error(error) });
            } else {
              this.$router.push({ name: 'home' }).catch((error) => { if (error) console.error(error) });
            }
					}, 300);
				}).catch(() => {
					this.invalidCredentials = true;
					this.$notify({
						group: 'app',
						title: 'Inloggen',
						type: 'error',
						text: 'Inloggegevens zijn niet correct.'
					});
				});
			},
      verifyTotpForm() {
        this.hidden = false;
        this.invalidCode = false;

        this.verifyTotp({
          code: this.code,
          trusted_device: this.trusted_device,
        }).then((viewer) => {
          this.hidden = true;
          this.invalidCode = false;

          this.$notify({
            group: 'app',
            title: 'Inloggen',
            type: 'success',
            text: `Welkom ${viewer.display_name != null ? viewer.display_name : viewer.username}`
          });

          setTimeout(() => {
            if(this.returnUrl != null) {
              this.$router.push({path: this.returnUrl}).catch((error) => { if (error) console.error(error) });
            } else {
              this.$router.push({ name: 'map' }).catch((error) => { if (error) console.error(error) });
            }
          }, 300);
        }).catch((error) => {
			console.log(error);
          this.invalidCode = true;
          this.$notify({
            group: 'app',
            title: 'Inloggen',
            type: 'error',
            text: '2fa code is niet correct.'
          });
        });
      }
		}
	};
</script>

<style lang="scss">
.checkbox-container {
	display: grid;
	grid-template-columns: auto 1fr;
	align-items: center;
	margin: 0;
}

.checkbox-container label {
	padding: 8px;
}

.checkbox {
	height: 24px;
	width: 24px;
	accent-color: #35a5a4;
}
</style>
